import clsx from "clsx";

export default function UnderlinedSectionHeader({ children, className }) {
    return (
        <div className={parentContainerStyle + className}>
            {children}
            <div className={borderStyle}></div>
        </div>
    );
}

const borderStyle = clsx("mt-3 lg:mt-6 w-[80%] border-b-2 -ml-[6px]");
const parentContainerStyle = clsx(
    "md:text-7xl text-3xl font-header tracking-widest max-w-[600px]",
    " w-fit text-center font-bold uppercase flex flex-col items-center ",
);
